<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ getText(processConfig?.globalizationConfig, 'title') | uppercase }}
            </ion-label>
        </ion-item>

        <app-step-description
            [description]="getText( processConfig?.globalizationConfig, 'instructions' )"></app-step-description>

        <ion-card mode="ios" class="card-table-data" *ngIf="processConfig">
            <ion-grid>
                <ion-row class="ion-no-padding">
                    <ion-col size="12" class="ion-no-padding">
                        <app-subordinate-profile
                            [user]="userPreview"
                            [getImageUrl]="getImageUrl.bind(this)">
                        </app-subordinate-profile>
                    </ion-col>
                </ion-row>
                <ion-row class="ion-no-padding">
                    <ion-col size="8" class="ion-no-padding">
                        <ion-list class="inputs-progress">
                            <ion-list-header>
                                <ion-label style="font-size: 16px; margin-top: 0px;">
                                    {{ 'goalsInput.totalWeight' | translate }}: {{ getTotalWeight() }}% / 100%
                                </ion-label>
                            </ion-list-header>
                            <ion-progress-bar [value]="getTotalWeight() / 100"></ion-progress-bar>
                        </ion-list>
                    </ion-col>
                    <ion-col size="4">
                        <ion-card-header
                            *ngIf="canApproveGoals(subordinateGoals?.goals) && stepStatus !== ProcessStatusEnum.AllowedViewing"
                            goRight>
                            <ion-button mode="ios" color="secondary" (click)="openNewGoalModal()">
                                {{ 'goalsValidation.newGoal' | translate }}
                            </ion-button>
                        </ion-card-header>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>

        <ion-card class="table-view" style="margin: 10px 0;" *ngIf="processConfig">
            <app-user-goals-list [goals]="displayedGoals" [goalsInputConfig]="processConfig"
                [processType]="ProcessType.GoalInputValidation"
                [canEditGoals]="canApproveGoals(displayedGoals) && stepStatus !== ProcessStatusEnum.AllowedViewing"
                (edit)="openManageGoalsInputModal($event.goal)" (viewGoalProgress)="viewGoalProgress($event)">
            </app-user-goals-list>
        </ion-card>

        <ng-container
            *ngIf="canApproveGoals(subordinateGoals?.goals) && stepStatus !== ProcessStatusEnum.AllowedViewing && processConfig">
            <div class="bottom-buttons ion-text-right">
                <ion-button mode="ios" color="secondary" class="send"
                    (click)="setGoalsFeedbacks(subordinateGoals.goals)">
                    {{ 'generic.finish' | translate }}
                </ion-button>
            </div>
        </ng-container>
    </div>
</ion-content>